import { useState, useEffect } from "react";
import AdvisorShareHttpClient from "../../../core/infrastructure/clients/v2/AdvisorShareHttpClient";
import { useAuth0 } from "@auth0/auth0-react";
import { IAdvisorLedgerResponse, IAdvisorActivityLedgerEntry } from "../../../types/database";

const client = new AdvisorShareHttpClient();

export const useAdvisorLedger = (advisorId: string, projectTag?: string) => {
    const { getAccessTokenSilently } = useAuth0();
    const [ledger, setLedger] = useState<IAdvisorActivityLedgerEntry[] | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>(null);

    useEffect(() => {
        if (!advisorId) return;
        setLoading(true);
        getAccessTokenSilently().then(token => {
            client.getAdvisorLedger(token, advisorId, projectTag).then(({ data, error }) => {
                if (data) {
                    setLedger(data.ledger);
                }
                setError(error);
                setLoading(false);
            });
        });
    }, [advisorId, projectTag, getAccessTokenSilently]);

    return { ledger, loading, error };
}; 